export default "__VITE_ASSET__BYIBy9jl__"